import {
  ChangeDetectionStrategy,
  Component,
  DOCUMENT,
  ElementRef,
  HostListener,
  inject,
  input,
  OnInit,
  signal,
  viewChild,
  viewChildren,
} from '@angular/core';
import { contentLayout11Style } from '@components/content/components/content-layout-11/config';
import { ContentLayout11, ContentLayout11Style } from '@components/content/components/content-layout-11/model';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { ColorPipe } from '@shared/pipes';

@Component({
  selector: 'app-content-layout-11',
  imports: [TitleComponent, ColorPipe],
  templateUrl: './content-layout-11.component.html',
  styleUrl: './content-layout-11.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentLayout11Component implements OnInit {
  readonly sectionElement = viewChild.required<ElementRef<HTMLElement>>('sectionElement');
  readonly textWrapperElement = viewChild.required<ElementRef<HTMLElement>>('textWrapperElement');
  readonly textElements = viewChildren('textElements', { read: ElementRef });
  readonly data = input.required<ContentLayout11>();
  text = signal<string[]>(null!);
  title = signal<Title>(null!);
  style = signal<ContentLayout11Style>(null!);
  readonly #window = inject<Document>(DOCUMENT).defaultView as Window;

  @HostListener('window:scroll') onScrollEvent() {
    const textWrapper = this.textWrapperElement().nativeElement;
    const offset = this.sectionElement().nativeElement.offsetHeight / 2;
    if (
      this.#window.scrollY >= textWrapper.offsetTop - offset &&
      this.#window.scrollY <= textWrapper.offsetTop - offset + textWrapper.offsetHeight
    ) {
      const percent =
        Math.round(((this.#window.scrollY - textWrapper.offsetTop + offset) / textWrapper.offsetHeight) * 100) / 100;
      this.textElements().forEach((textElement, i) => {
        const el = (textElement as ElementRef<HTMLElement>).nativeElement;
        if (i <= percent * this.textElements().length) {
          el.classList.add('show');
          el.classList.remove('hide');
        }

        if (i >= percent * this.textElements().length) {
          el.classList.add('hide');
          el.classList.remove('show');
        }
      });
    }
  }

  ngOnInit(): void {
    this.style.set(contentLayout11Style[this.data().theme ?? 'BLUE']!);
    this.text.set(this.data().text.split(' '));
    this.title.set({
      level: 'H2',
      type: 'SLASH',
      size: {
        mobile: 'SPAN',
        desktop: 'SPAN',
      },
      weight: 500,
      color: this.style().labelColor,
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      text: this.data().title,
    });
  }
}
